import { Component, OnInit } from '@angular/core';
import { GamesGroupService, GroupType, IGroupSummary, ProgressStatus, SortFn, TriviaGroupSummary } from '@fgb/core';
import { Observable } from 'rxjs';
import { filterBy, sortBy } from '@fgb/portal-component-library/src/lib/shared/utilities';
import { FgbModalService } from 'src/app/shared/components/modals/fgb-modal.service';
import { QuizHowItWorksModalComponent } from 'src/app/pages/quiz-page/quiz-how-it-works-modal/quiz-how-it-works-modal.component';

enum GAME_TAB {
  LIVE_UPCOMING = 0,
  RESULTS = 1,
}

@Component({
  selector: 'fgb-quiz-page',
  templateUrl: './quiz-page.component.html',
  styleUrls: ['./quiz-page.component.scss'],
})
export class QuizPageComponent implements OnInit {
  gamesGroup$: Observable<TriviaGroupSummary[]>;
  groupType = GroupType.Trivia;
  filters: any = [];
  sort: SortFn[] = [];
  currentTab: GAME_TAB = GAME_TAB.LIVE_UPCOMING;
  GAME_TAB = GAME_TAB;

  constructor(private gamesGroupService: GamesGroupService, private modalService: FgbModalService) {}

  ngOnInit() {
    this.gamesGroup$ = this.gamesGroupService.fetchTriviaGroups();
  }

  onTabChage(tab: GAME_TAB): void {
    this.currentTab = tab;
    const defaultSort: SortFn[] = [
      (a, b) => {
        const statusOrder = [
          ProgressStatus.InProgress,
          'Featured',
          ProgressStatus.NotStarted,
          'ComingSoon',
          ProgressStatus.Completed,
        ];
        const getStatusIndex = (group: IGroupSummary) => {
          if (group.Status === ProgressStatus.NotStarted && group.ComingSoon) {
            return statusOrder.indexOf('ComingSoon');
          }
          if (group.Status === ProgressStatus.NotStarted && group.Featured) {
            return statusOrder.indexOf('Featured');
          }
          return statusOrder.indexOf(group.Status);
        };
        return getStatusIndex(a) - getStatusIndex(b);
      },
    ];
    if (tab === GAME_TAB.LIVE_UPCOMING) {
      this.filters = [filterBy({ EntityGroupCompleted: false }), filterBy({ Status: ProgressStatus.Completed }, '!=')];
      this.sort = [...defaultSort, sortBy('StartDate', 'asc', { type: 'date' })];
    } else if (tab === GAME_TAB.RESULTS) {
      this.filters = [
        filterBy({ EntityGroupCompleted: true }),
        { operator: 'or' },
        filterBy({ Status: ProgressStatus.Completed }),
      ];
      this.sort = [...defaultSort, sortBy('CompletionDate', 'desc', { type: 'date' })];
    }
  }

  open(): void {
    this.modalService.openBottomMenu(QuizHowItWorksModalComponent, {}, { startY: 100 });
  }
}
